import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { Link } from '@stackflow/link';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

import { currentCardAtom } from '../../atoms/prepaidCardAtoms';

function CardDetail() {
    const { t } = useTranslation('prepaidCard');
    const card = useAtomValue(currentCardAtom);
    return (
        <Container fullWidth
            as='section'
            spacing={12}
            align='center' >
            <Text color={colors.gray7}
                fontWeight='bold'
                size='2xl' >
                {card?.name}
            </Text>
            <Row spacing={8}>
                <Text size='xl' fontWeight='bold' color={colors.gray6}>
                    {t('balance')}
                </Text>
                <Row>
                    <Text size='3xl' fontWeight='bold' color={colors.gray8}>
                        {card?.balance.toLocaleString()}
                    </Text>
                    <Text size='xl' fontWeight='bold' color={colors.gray6}>
                        {t('currencyUnit')}
                    </Text>
                </Row>
                {card && (
                    <Link activityParams={{ prepaidCardId: card.id }}
                        activityName='PrepaidCardChargeActivity' >
                        <ChargeButton>
                            {t('charge.message')}
                        </ChargeButton>
                    </Link>
                )}

            </Row>
            <Barcode spacing={4}
                align='center' >
                <CustomBarcode value={card?.barcodeNo || ''}/>
                <Text>
                    {card?.barcodeNo}
                </Text>
            </Barcode>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 32px 0;
`;

const Barcode = styled(Column)`
    background-color: var(--color-white);
    margin-top: 8px;
    max-width: 222px;
`;

const ChargeButton = styled.button`
    background-color: transparent;
    border: 1px solid var(--color-primary);
    border-radius: 20px;
    color: var(--color-gray6);
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    padding: 6px 22px;
`;

export default CardDetail;
